export const DownloadIcon = () => (
  <svg
    width="20"
    height="27"
    viewBox="0 0 20 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.33333 0C1.49479 0 0 1.51348 0 3.375V23.625C0 25.4865 1.49479 27 3.33333 27H16.6667C18.5052 27 20 25.4865 20 23.625V8.4375H13.3333C12.4115 8.4375 11.6667 7.6834 11.6667 6.75V0H3.33333ZM13.3333 0V6.75H20L13.3333 0ZM11.25 12.2344V17.6186L12.8646 15.9838C13.3542 15.4881 14.1458 15.4881 14.6302 15.9838C15.1146 16.4795 15.1198 17.2811 14.6302 17.7715L10.8802 21.5684C10.3906 22.0641 9.59896 22.0641 9.11458 21.5684L5.36458 17.7715C4.875 17.2758 4.875 16.4742 5.36458 15.9838C5.85417 15.4934 6.64583 15.4881 7.13021 15.9838L8.74479 17.6186L8.75 12.2344C8.75 11.533 9.30729 10.9688 10 10.9688C10.6927 10.9688 11.25 11.533 11.25 12.2344Z"
      fill="black"
    />
  </svg>
);
